<div mat-dialog-title>Terms and Conditions</div>

<div mat-dialog-content class="terms-content">
  <h4>Keeping your personal data safe</h4>
  <p>
    LAUTEC complies with the General Data Protection Regulation (GDPR) of the
    European Union. You can read below how your personal data is managed by
    LAUTEC.
  </p>

  <h4>Personal data we collect</h4>
  <p>
    LAUTEC stores the identification and contact information available on the
    user profile page.
  </p>

  <h4>How we use personal data</h4>
  <p>
    We use your personal data to maintain a list of user accounts and to assign
    user access rights.
  </p>

  <h4>Who the personal data is available for</h4>
  <p>
    Your personal data is available for admin users on your LAUTEC system
    account and for LAUTEC IT developers.
  </p>

  <h4>How to access and control your personal data</h4>
  <p>
    You can view, edit and request deletion of your personal data on your user
    profile page.
  </p>

  <h4>System data saved on your device</h4>
  <p>
    The system saves information in the cache of the browser and your browser
    may offer to remember your login details.
  </p>

  <div class="mt-2">
    <p class="text-red" [class.invisible]="consentChecked">
      You must accept the terms and conditions before using the application
    </p>

    <mat-checkbox [(ngModel)]="consentChecked">
      <span class="customLabel">I agree to the terms and conditions</span>
    </mat-checkbox>
  </div>
</div>

<div mat-dialog-actions>
  <button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="true"
    [disabled]="!consentChecked"
  >
    Submit
  </button>
  <button mat-button color="primary" (click)="onCancel()">Log out</button>
</div>
